export enum DatepickerTimeRangeTips {
  Today = 1,
  Yesterday = 2,
  DayBeforeYesterday = 3,
  PreviousWeek = 4,
  PreviousMonth = 5,
}
